import * as THREE from 'three';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { FikoCizimler } from '../../IFikoThreeJS/FikoThreeCam/FikoCizimler';
import { FikoKaynakca } from '../../IFikoThreeJS/FikoThreeCam/FikoKaynakca';
import { FikoOperasyonlar } from '../../IFikoThreeJS/FikoThreeCam/Fikoperasyonlar';
import { FikoIsiklar } from '../../IFikoThreeJS/FikoIsiklar';
import { FikoEtiketler } from '../../IFikoThreeJS/FikoEtiketler';
import { FikoThreeJsComponent } from '../../fiko-three-js.component';
import { FikoSahne } from '../../IFikoThreeJS/FikoSahne';
import { FikoCizimYalin } from '../../IFikoThreeJS/FikoCizimYalin';
import { FikoObje3D } from '../../IFikoThreeJS/FikoObje3D';
import { FikoGrup } from '../../IFikoThreeJS/FikoGrup';
import { FikoIsikOrtam } from '../../IFikoThreeJS/FikoIsikOrtam';
import { FikoIsikYonsel } from '../../IFikoThreeJS/FikoIsikYonsel';
import { FikoVektor3D } from '../../IFikoThreeJS/FikoVektor3d';
declare var TWEEN: any;

/**
 * STP/STEP dosyalarını görüntülemek için basit sahne
 */
export class SahneStepViewer extends FikoSahne {
    /** Standart Gruplar */
    cizimler: FikoCizimler;
    kaynakca: FikoKaynakca;
    kaynakcaIsiklar: FikoIsiklar;
    fikoEtiketler: FikoEtiketler;
    /** CAM Operasyonlar */
    operasyonlar: FikoOperasyonlar;

    /** Alt araç çubuğu butonları */
    altAracCubugu = [
        {
            simge: "exchange alternate",
            simgeYazi: "",
            baslik: "CAD Farklar",
            aciklama: "İki modeli karşılaştır, farkları göster",
            renkSinif: "teal",
            tiklandi: (_event?: any) => {
                this.acCadDiffDialog();
            }
        }
    ];
    constructor(public override anaGosterim: FikoThreeJsComponent) {
        super(anaGosterim);

        // Çizimler grubu oluştur
        this.cizimler = new FikoCizimler(this, "Fiko Çizimler");

        // Kaynakça grubu oluştur
        this.kaynakca = new FikoKaynakca(this, "Kaynakça");

        // Işıklar
        this.kaynakcaIsiklar = new FikoIsiklar(this, "Işıklar");

        // Ana ortam ışığı
        let anaOrtamIsigi = new FikoIsikOrtam(this, "Ana Ortam Işığı");
        anaOrtamIsigi.intensity = 1.5;
        this.kaynakcaIsiklar.ekle(anaOrtamIsigi);

        // Yönsel ışık (CAD görünümü için optimize edilmiş)
        let yonselIsigi = new FikoIsikYonsel(this, "Yönsel Işık");
        yonselIsigi.intensity = 1.2;
        yonselIsigi.kameraOffsetUzakligi = 50; // Kameradan 50 unit geri
        yonselIsigi.kameraTakipAktif = true; // ✅ DİNAMİK IŞIK MODU (kamera takip açık)
        this.kaynakcaIsiklar.ekle(yonselIsigi);

        // Kamera listener'ını kur - ışık kamerayı takip etsin
        this.kuruKameraListenerYonselIsik(yonselIsigi);

        this.kaynakca.ekle(this.kaynakcaIsiklar);

        // 📝 Fiko-Etiketler grubu oluştur (Annotation'lar için)
        this.fikoEtiketler = new FikoEtiketler(this, "Fiko-Etiketler");
        this.kaynakca.ekle(this.fikoEtiketler);

        // 🔧 CAM Operasyonlar grubu oluştur
        this.operasyonlar = new FikoOperasyonlar(this, "FikoYT Operasyonlar");

        // 🔗 Dialog açma metotlarını bind et
        this.bindAnnotationDialogs();

        // Ürün ağacına ekle
        this.urunAgaci.add(this.cizimler);
        this.urunAgaci.add(this.operasyonlar);
        this.urunAgaci.add(this.kaynakca);

        // // Varsayılan kamera pozisyonları
        // let kameraListe = [
        //     {
        //         "ismi": "Varsayılan Görünüm",
        //         "aciklama": "STP model görüntüleyici varsayılan kamera pozisyonu",
        //         "veri": {
        //             "matriks": [
        //                 0.7071067811865476, -0.40824829046386296, 0.5773502691896258, 0,
        //                 0, 0.8164965809277261, 0.5773502691896257, 0,
        //                 -0.7071067811865475, -0.40824829046386313, 0.5773502691896258, 0,
        //                 -0.1, 0.1, 0.15, 1
        //             ],
        //             "hedef": [0, 0, 0],
        //             "position": [-0.1, 0.1, 0.15],
        //             "quaternion": [0.2705980500730985, 0.6532814824381883, 0.6532814824381882, 0.27059805007309856],
        //             "scale": [1, 1, 1],
        //             "ust": [0, 0.8164965809277258, 0.5773502691896258],
        //             "yakinlik": 1.0,
        //             "oran": 1.5
        //         }
        //     }
        // ];

        // // Kamera pozisyonlarını kaydet
        // for (let i = 0; i < kameraListe.length; i++) {
        //     const element = kameraListe[i];
        //     this.kaynakca.konumlar.kaydet(element.ismi, element.aciklama, element.veri);
        // }

        // Sahneyi güncelle
        this.guncelle();
        this.anaGosterim.FikoYT.degisti.emit();

        // İlk kamera pozisyonuna git ve ekrana sığdır
        // setTimeout(async () => {
        //     if (this.kaynakca.konumlar.liste.length > 0) {
        //         await this.kaynakca.konumlar.liste[0].git(1000);
        //         setTimeout(() => {
        //             this.ekranaSigdir(this);
        //         }, 700);
        //     }
        // }, 500);
    }

    hazirla() {
        // Sahne hazırlama işlemleri
    }

    guncelle() {
        this.anaGosterim.ciz();
    }

    /**
     * Tüm FikoCizimYalin objelerini ekrana sığdır
     */
    ekranaSigdir(obj: THREE.Object3D = this) {
        let geometriler: THREE.BufferGeometry[] = [];

        obj.traverse((elm: any) => {
            if (elm.type == "FikoCizimYalin") {
                const cizimYalin = elm as FikoCizimYalin;
                if (cizimYalin.mesh?.geometry) {
                    geometriler.push(cizimYalin.mesh.geometry);
                }
            }
        });

        if (geometriler.length === 0) return;

        let buffers = BufferGeometryUtils.mergeGeometries(geometriler);

        if (!buffers) {
            for (const geometry of geometriler) {
                if (geometry && geometry.attributes && geometry.attributes.position) {
                    buffers = geometry;
                    break;
                }
            }
            if (!buffers) return;
        }

        buffers.computeBoundingSphere();

        const boundingSphere = buffers.boundingSphere;
        const radius = boundingSphere.radius;
        const center = boundingSphere.center;

        const canvasWidth = this.anaGosterim.canvas.nativeElement.clientWidth;
        const canvasHeight = this.anaGosterim.canvas.nativeElement.clientHeight;
        const aspect = canvasWidth / canvasHeight;

        let yakinlik = (aspect > 1.0)
            ? canvasHeight / (radius * 2)
            : canvasWidth / (radius * 2);

        yakinlik *= 0.85;
        if (yakinlik < 0.1) yakinlik = 0.1;

        let hedefPoz = center.clone();
        let kameraYonu = this.anaGosterim.aktifKamera.position.clone().sub(this.anaGosterim.aktifKontrol.target).normalize();
        let kameraMesafesi = radius * 2;
        let yeniKameraPoz = hedefPoz.clone().add(kameraYonu.multiplyScalar(kameraMesafesi));

        this.anaGosterim.surekliCiz();

        const kameraPromise = new Promise<void>(resolve => {
            new TWEEN.Tween(this.anaGosterim.aktifKamera)
                .to({
                    zoom: yakinlik,
                    position: { x: yeniKameraPoz.x, y: yeniKameraPoz.y, z: yeniKameraPoz.z }
                }, 800)
                .onUpdate(() => {
                    this.anaGosterim.aktifKamera.updateProjectionMatrix();
                })
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => resolve())
                .start();
        });

        const kontrolPromise = new Promise<void>(resolve => {
            new TWEEN.Tween(this.anaGosterim.aktifKontrol)
                .to({
                    target: { x: hedefPoz.x, y: hedefPoz.y, z: hedefPoz.z }
                }, 800)
                .onUpdate(() => {
                    this.anaGosterim.aktifKontrol.update();
                })
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => resolve())
                .start();
        });

        Promise.all([kameraPromise, kontrolPromise])
            .then(() => {
                this.anaGosterim.surekliCizIptal();
                buffers.dispose();
            })
            .catch(() => {
                this.anaGosterim.surekliCizIptal();
                buffers.dispose();
            });
    }

    /**
     * Göreceli zoom
     * @param offsetZoom Zoom ofseti (0.5 = %50 yakınlaştır)
     * @param zaman Animasyon süresi (ms)
     */
    async relativeZoom(offsetZoom = 0.5, zaman = 1000) {
        return new Promise((resolve, reject) => {
            let yakinlik = this.anaGosterim.aktifKamera.zoom;

            // Animasyon için continuous render başlat
            this.anaGosterim.surekliCiz();

            const zoomTween = new TWEEN.Tween(this.anaGosterim.aktifKamera)
                .to({ zoom: yakinlik * (1 + offsetZoom) }, zaman)
                .onUpdate(() => {
                    this.anaGosterim.aktifKamera.updateProjectionMatrix();
                })
                .easing(TWEEN.Easing.Quadratic.Out);

            zoomTween.onComplete(() => {
                // Animasyon bitti, continuous render'ı durdur
                this.anaGosterim.surekliCizIptal();
                resolve(true);
            }).start();
        });
    }


    /**
     * 3D Uyarı Dialog'unu Aç - Standalone modda devre dışı
     */
    uyar3DDialogAc() {
        // Standalone modda devre dışı
    }

    /**
     * Yönsel ışık için kamera listener'ı kur
     * Işık, kamera look direction'ından geliyormuş gibi parlar ama model merkezine bakır
     * @param yonselIsigi Takip edilecek yönsel ışık
     */
    kuruKameraListenerYonselIsik(yonselIsigi: FikoIsikYonsel) {
        // Başlangıçta pozisyonu kaydet (sabit mod için)
        const sabitPozisyon = yonselIsigi.position.clone();

        // FikoIsikYonsel'in kendi updateLightPosition metodunu kullan
        // Her render frame'inde ışık pozisyonunu güncelle
        const originalCiz = this.anaGosterim.ciz.bind(this.anaGosterim);
        this.anaGosterim.ciz = () => {
            if (yonselIsigi.kameraTakipAktif) {
                // Kamera takip aktif: pozisyonu güncelle
                yonselIsigi.updateLightPosition();
            } else {
                // Kamera takip kapalı: sabit pozisyonu koru
                yonselIsigi.position.copy(sabitPozisyon);

                // Manuel modda target'ı da sabit tut
                // Işık model merkezi yerine mevcut konumuna bakmalı
                const hedef = new THREE.Vector3(0, 0, 0);
                yonselIsigi.target.position.copy(hedef);
                yonselIsigi.target.updateMatrixWorld();
                yonselIsigi.updateMatrixWorld();
            }
            originalCiz();
        };

        // İlk çalıştırma
        if (yonselIsigi.kameraTakipAktif) {
            yonselIsigi.updateLightPosition();
        } else {
            // Sabit modda başlangıç pozisyonunu ayarla
            yonselIsigi.position.copy(sabitPozisyon);
        }
    }

    /**
     * 🔗 Annotation Dialog'larını FikoEtiketler'e bağla
     * Dynamic imports kullanarak circular dependency'den kaçınıyoruz
     */
    private async bindAnnotationDialogs(): Promise<void> {
        // Metin Notu Dialog
        this.fikoEtiketler.acDialogMetinNotu = async () => {
            const { FikoMetinNotuComponent } = await import('../../fiko-annotation/fiko-metin-notu/fiko-metin-notu.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoMetinNotuComponent,
                ayarlar: {
                    baslik: 'Metin Notu Ekle',
                    genislik: 320,
                    yukseklik: 'auto',
                    anahtar: 'metin-notu-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Boyut Ölçüsü Dialog
        this.fikoEtiketler.acDialogBoyutOlcusu = async () => {
            const { FikoBoyutOlcusuComponent } = await import('../../fiko-annotation/fiko-boyut-olcusu/fiko-boyut-olcusu.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoBoyutOlcusuComponent,
                ayarlar: {
                    baslik: 'Boyut Ölçüsü Ekle',
                    genislik: 320,
                    yukseklik: 'auto',
                    anahtar: 'boyut-olcusu-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Ok İşaretçi Dialog
        this.fikoEtiketler.acDialogOkIsaretci = async () => {
            const { FikoOkIsaretciComponent } = await import('../../fiko-annotation/fiko-ok-isaretci/fiko-ok-isaretci.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoOkIsaretciComponent,
                ayarlar: {
                    baslik: 'Ok İşaretçi Ekle',
                    genislik: 320,
                    yukseklik: 'auto',
                    anahtar: 'ok-isaretci-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Bayrak Dialog
        this.fikoEtiketler.acDialogBayrak = async () => {
            const { FikoBayrakComponent } = await import('../../fiko-annotation/fiko-bayrak/fiko-bayrak.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoBayrakComponent,
                ayarlar: {
                    baslik: 'Bayrak Ekle',
                    genislik: 320,
                    yukseklik: 'auto',
                    anahtar: 'bayrak-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Geometrik Tolerans Dialog
        this.fikoEtiketler.acDialogGeometrikTolerans = async () => {
            const { FikoGeometrikToleransComponent } = await import('../../fiko-annotation/fiko-geometrik-tolerans/fiko-geometrik-tolerans.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoGeometrikToleransComponent,
                ayarlar: {
                    baslik: 'Geometrik Tolerans Ekle',
                    genislik: 340,
                    yukseklik: 'auto',
                    anahtar: 'geometrik-tolerans-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Datum Özellik Dialog
        this.fikoEtiketler.acDialogDatumOzellik = async () => {
            const { FikoDatumOzellikComponent } = await import('../../fiko-annotation/fiko-datum-ozellik/fiko-datum-ozellik.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoDatumOzellikComponent,
                ayarlar: {
                    baslik: 'Datum Özellik Ekle',
                    genislik: 320,
                    yukseklik: 'auto',
                    anahtar: 'datum-ozellik-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Yüzey Kalitesi Dialog
        this.fikoEtiketler.acDialogYuzeyKalite = async () => {
            const { FikoYuzeyKaliteComponent } = await import('../../fiko-annotation/fiko-yuzey-kalite/fiko-yuzey-kalite.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoYuzeyKaliteComponent,
                ayarlar: {
                    baslik: 'Yüzey Kalitesi Ekle',
                    genislik: 340,
                    yukseklik: 'auto',
                    anahtar: 'yuzey-kalite-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };

        // Kaynak Sembolü Dialog
        this.fikoEtiketler.acDialogKaynakSembol = async () => {
            const { FikoKaynakSembolComponent } = await import('../../fiko-annotation/fiko-kaynak-sembol/fiko-kaynak-sembol.component');
            this.anaGosterim.DialogFiko.ac({
                bilesen: FikoKaynakSembolComponent,
                ayarlar: {
                    baslik: 'Kaynak Sembolü Ekle',
                    genislik: 340,
                    yukseklik: 'auto',
                    anahtar: 'kaynak-sembol-dialog'
                },
                parametreler: {
                    anaGosterim: this.anaGosterim
                }
            });
        };
    }

    /**
     * 🔀 CAD Diff Dialog'unu aç
     * İki modeli karşılaştırma ve farkları görselleştirme
     */
    async acCadDiffDialog(): Promise<void> {
        const { FikoCadDiffComponent } = await import('../../IFikoThreeJS/fiko-cad-diff/fiko-cad-diff.component');
        this.anaGosterim.DialogFiko.ac({
            bilesen: FikoCadDiffComponent,
            ayarlar: {
                baslik: 'CAD Farklar - Model Karşılaştırma',
                genislik: 340,
                yukseklik: 'auto',
                anahtar: 'cad-diff-dialog'
            },
            parametreler: {
                sahne: this
            }
        });
    }
}
